import { Box, Chip, colors, Divider, Grid2, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as TrophyIcon } from "Assets/Icons/Home/TrophyIcon.svg";
import { ReactComponent as SkillCertificate } from "Assets/Icons/Leaderboard/SkillCertificate.svg";
import { ReactComponent as ProblemSolving } from "Assets/Icons/Leaderboard/ProblemSolving.svg";
import { ReactComponent as StreakIcon } from "Assets/Icons/Home/StreakIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import CircularProgressWithLabel from "Components/Common/CircularProgressWithLabel";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const styles = (theme) => ({
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
  "&>div": {
    border: `1px solid ${theme.palette.border.blue}`,
    borderRadius: "8px",
    padding: "16px",
    display: "flex",
    alignItems: "start",
    justifyContent: "space-between",
    transition: "background-color 0.3s ease, color 0.3s ease",
    cursor: "pointer",
    "& .streaks": {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      "& svg": {
        background: theme.palette.background.default,
        padding: "1px",
        borderRadius: "50%",
      },
    },
  },
  "& .active": {
    background: theme.palette.primary.main,
    color: theme.palette.white.main,
    "& svg": {
      fill: theme.palette.white.main,
    },
    "& .MuiChip-root": {
      borderColor: theme.palette.white.main,
      background: `${theme.palette.white.main}`,
    },
  },
});

const LeaderBoardCards = () => {
  const params = useParams();
  const navigate = useNavigate();

  const { CurrentUser, Translation } = useSelector((state) => ({
    CurrentUser: state.LeaderBoard.currentUser,
    Translation: state.Translation.translation?.LeaderBoard || {},
  }));

  return (
    <Grid2
      sx={styles}
      container
      spacing={2}
      columns={{ xl: 12, lg: 12, md: 6, sm: 6 }}
    >
      <Grid2
        size={3}
        className={params?.tab == "rank" || !params?.tab ? "active" : ""}
        onClick={() => navigate("/global-leaderboard/rank")}
      >
        <Box>
          <Typography variant="title" fontWeight={500}>
            {Translation?.LeaderBoard}
          </Typography>
          <Typography>{Translation?.ProblemSolvingPercentage} {CurrentUser?.ProblemSolved}</Typography>
        </Box>
        <Box display={"flex"} alignItems={"center"} gap="5px">
          {" "}
          <PrimaryIcon
            icon={TrophyIcon}
            fill={false}
            height="24px"
            width="24px"
          />{" "}
          <Typography fontWeight={600} fontSize={28}>
            {CurrentUser?.Rank}
          </Typography>
        </Box>
      </Grid2>
      <Grid2
        size={3}
        className={params?.tab == "skill" ? "active" : ""}
        onClick={() => navigate("/global-leaderboard/skill")}
      >
        <Box>
          <Typography variant="title" fontWeight={500}>
            {Translation?.SkillCertificates}
          </Typography>
        </Box>
        <Box display={"flex"} alignItems={"center"} gap="5px">
          {" "}
          <PrimaryIcon
            icon={SkillCertificate}
            height="24px"
            width="24px"
          />{" "}
          <Typography fontWeight={600} fontSize={28}>
            0
          </Typography>
        </Box>
      </Grid2>
      <Grid2
        size={3}
        className={params?.tab == "attendance" ? "active" : ""}
        onClick={() => navigate("/global-leaderboard/attendance")}
      >
        <Box display={"flex"} flexDirection={"column"} gap="8px">
          <Typography variant="title" fontWeight={500}>
            {Translation?.Attendance}
          </Typography>
          <Chip
            outlined
            variant="outlined"
            color="primary"
            label={
              <Typography variant="body2" color="secondary.light">
                {Translation?.AttendanceStreaks}
              </Typography>
            }
          />
        </Box>
        <Box display={"flex"} alignItems={"center"} gap="15px">
          <CircularProgressWithLabel color="error" value={CurrentUser?.Attendance} />

          <Divider primary flexItem orientation="vertical" variant="middle" />

          <Typography className="streaks" fontWeight={600} fontSize={28}>
            <PrimaryIcon
              height="32px"
              width="32px"
              icon={StreakIcon}
              fill={false}
            />
            0
          </Typography>
        </Box>
      </Grid2>
      <Grid2
        size={3}
        className={params?.tab == "problem" ? "active" : ""}
        onClick={() => navigate("/global-leaderboard/problem")}
      >
        <Box display={"flex"} flexDirection={"column"} gap="8px">
          <Typography
            display={"flex"}
            alignItems={"center"}
            gap="8px"
            variant="title"
            fontWeight={500}
          >
            <PrimaryIcon height="20px" width="20px" icon={ProblemSolving} />
              {Translation?.ProblemSolving}
          </Typography>
        </Box>
        <Box display={"flex"} alignItems={"center"} gap="15px">
          <CircularProgressWithLabel color="error" value={CurrentUser?.ProblemSolvedCount} />

          <Divider primary flexItem orientation="vertical" variant="middle" />

          <Typography className="streaks" fontWeight={600} fontSize={28}>
            <PrimaryIcon
              height="32px"
              width="32px"
              icon={StreakIcon}
              fill={false}
            />
            0
          </Typography>
        </Box>
      </Grid2>
    </Grid2>
  );
};

export default LeaderBoardCards;
